"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimsWidgetHelper = void 0;
var ClaimsWidgetHelper = /** @class */ (function () {
    function ClaimsWidgetHelper() {
    }
    ClaimsWidgetHelper.claimContents = function (i, parentObject, parentObjExpr, arrayExpression, arrayIndex) {
        var readOnlyExpression = "isSet(elementAt(elementAt(elementAt(".concat(parentObjExpr, ", 'claims'), ").concat(i, "), 'existing')) and elementAt(elementAt(elementAt(").concat(parentObjExpr, ", 'claims'), ").concat(i, ") , 'existing')");
        return [
            {
                name: "ClaimPanel".concat(i + 1),
                type: "panel",
                settings: {
                    cssClass: "w-100 pb-3 ".concat(i > 0 ? 'border-top-dashed-blue' : '')
                },
                questions: [
                    {
                        name: "claim_".concat(i + 1, "_date"),
                        label: "Date of claim",
                        type: "customMonth",
                        interactionField: "".concat(parentObject, ".claims[").concat(i, "].date"),
                        settings: {
                            readOnlyExpression: readOnlyExpression,
                            validFeedback: true,
                            showLabels: true
                        },
                        validations: [
                            {
                                type: "mandatory"
                            },
                            {
                                type: "date",
                                settings: {
                                    dateFormat: "MM/YYYY",
                                },
                                errorMessage: "Date is not valid. Example: 12/2019"
                            },
                            {
                                type: "dateMax",
                                settings: {
                                    dateFormat: "MM/YYYY",
                                    expression: "getDate()"
                                },
                                errorMessage: "Claim date can't be in the future"
                            },
                            {
                                type: "dateMin",
                                settings: {
                                    dateFormat: "MM/YYYY",
                                    expression: "getDate(0, 0, -5)"
                                },
                                errorMessage: "This date needs to be within the last 5 years."
                            }
                        ],
                        events: this.claimChangeEvent,
                    },
                    {
                        name: "claim_".concat(i + 1, "_description"),
                        label: "What happened?",
                        type: "dropDownBox",
                        interactionField: "".concat(parentObject, ".claims[").concat(i, "].claimType"),
                        settings: {
                            classifier: "claimType",
                            readOnlyExpression: readOnlyExpression,
                            validFeedback: true
                        },
                        validations: [
                            {
                                type: "mandatory"
                            }
                        ],
                        events: this.claimChangeEvent,
                    },
                    {
                        type: "link",
                        name: "Remove claim",
                        label: "Remove claim",
                        displayCondition: arrayExpression ? "isAd".concat(arrayIndex, "Claim").concat(i, "NotExisting") : "isPhClaim".concat(i, "NotExisting"),
                        settings: {
                            cssClass: "btn-text p-0 float-right"
                        },
                        events: {
                            onClick: {
                                commands: [
                                    {
                                        type: "removeChanges",
                                        settings: {
                                            changesToRemove: [
                                                "".concat(parentObject, ".claims[").concat(i, "].date"),
                                                "".concat(parentObject, ".claims[").concat(i, "].claimType"),
                                                "".concat(parentObject, ".hasClaims")
                                            ]
                                        }
                                    },
                                    {
                                        type: "setValue",
                                        settings: {
                                            binding: "".concat(parentObject, ".claims"),
                                            expression: arrayExpression ? "removeArrayElement(elementAt(".concat(parentObjExpr, ", 'claims'), ").concat(i, ")") : "removeArrayElement(".concat(parentObjExpr, ".claims, ").concat(i, ")")
                                        }
                                    },
                                    {
                                        type: "setValue",
                                        settings: {
                                            binding: "".concat(parentObject, ".numberOfClaims"),
                                            expression: "length(elementAt(".concat(parentObjExpr, ", 'claims'))")
                                        }
                                    },
                                    {
                                        type: "setValue",
                                        settings: {
                                            binding: "".concat(parentObject, ".hasClaims"),
                                            expression: "length(elementAt(".concat(parentObjExpr, ", 'claims')) > 0")
                                        }
                                    },
                                    {
                                        type: "setValue",
                                        settings: {
                                            binding: "uistate.claimChanged",
                                            expression: "true"
                                        }
                                    },
                                    {
                                        type: "setValue",
                                        settings: {
                                            binding: "uistate.interactionChangesDetected",
                                            expression: "true"
                                        }
                                    }
                                ]
                            }
                        }
                    }
                ]
            }
        ];
    };
    ClaimsWidgetHelper.claimChangeEvent = {
        onChange: {
            commands: [
                {
                    type: "setValue",
                    settings: {
                        binding: "uistate.claimChanged",
                        expression: "true"
                    }
                }
            ]
        }
    };
    return ClaimsWidgetHelper;
}());
exports.ClaimsWidgetHelper = ClaimsWidgetHelper;
//# sourceMappingURL=ClaimsWidgetHelper.js.map